import React from 'react';
import Button from '@justpark/ui/src/components/Button';
import type { CheckoutSummaryResult } from '../../generated/graphql';
import CheckoutSummary from './CheckoutSummary';

import styles from '../../../static/scss/components/listingDetails/dateSelectorWrapper.module.scss';

type UIProps = {
  isSubmitDisabled: boolean,
  onSubmit: () => void,
  t: (string, string) => string,
  checkoutSummary: ?CheckoutSummaryResult,
  loading: boolean,
  error: ?string,
  children: any,
  isMonthly: boolean
};

const DateSelectorWrapper = ({
  t,
  children,
  checkoutSummary,
  loading,
  error,
  isSubmitDisabled,
  onSubmit,
  isMonthly
}: UIProps) => (
  <div>
    {children}
    <div className={styles.priceWrapper}>
      <CheckoutSummary
        data={checkoutSummary}
        loading={loading}
        error={error}
        t={t}
        isMonthly={isMonthly}
      />
    </div>

    <Button
      className={styles.button}
      disabled={isSubmitDisabled}
      onClick={onSubmit}
      modifier="primary"
      cypress="book-space-button"
    >
      {t('cta:bookThisSpace', 'Book this space')}
    </Button>
  </div>
);

export default DateSelectorWrapper;
